// Strip tracking/campaign params from the URL — but only AFTER Google's tag has
// read them, so Ads conversion linking (gclid → _gcl_aw cookie) and GA4 source
// attribution stay intact. We wait for the _ga / _gcl_au cookie (proof gtag
// fired, post-consent) before cleaning the URL. If it never fires (consent
// denied / blocked) we leave the URL alone — there's no conversion to lose.
const TRACKING_PARAMS = [
    "gclid", "gclsrc", "gad_source", "gbraid", "wbraid", "dclid", "_gl", // Google
    "fbclid", // Meta
    "msclkid", // Microsoft
    "ttclid", // TikTok
    "li_fat_id", // LinkedIn
    "mc_cid", "mc_eid", // Mailchimp
    "igshid", // Instagram
];

const isTrackingParam = (key) => key.startsWith("utm_") || TRACKING_PARAMS.includes(key);

const stripParams = () => {
    const url = new URL(window.location.href);
    let changed = false;

    for (const key of [...url.searchParams.keys()]) {
        if (isTrackingParam(key)) {
            url.searchParams.delete(key);
            changed = true;
        }
    }

    if (changed) {
        window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }
};

const hasTracking = [...new URL(window.location.href).searchParams.keys()].some(isTrackingParam);

if (hasTracking) {
    // _ga = GA4 fired, _gcl_au = Google Ads/linker fired. Either means the tag
    // has already captured the params into its cookies.
    const tagFired = () => /(^|;\s*)(_ga|_gcl_au)=/.test(document.cookie);
    const deadline = Date.now() + 15000;

    const poll = setInterval(() => {
        if (tagFired()) {
            clearInterval(poll);
            stripParams();
        } else if (Date.now() > deadline) {
            clearInterval(poll); // tag never fired — leave the URL untouched
        }
    }, 250);
}
